import { PageShell } from "@/components/PageShell";
import { LegalPage } from "@/components/LegalPage";

const Privacidade = () => {
  return (
    <PageShell>
      <LegalPage title="Política de Privacidade" updated="7 de setembro de 2026">
        <p>
          A RODE IA LTDA, inscrita no CNPJ 68.764.921/0001-64, valoriza a
          privacidade e a proteção dos dados pessoais tratados em seus sites,
          aplicações, integrações e serviços.
        </p>

        <h2>1. Escopo</h2>
        <p>
          Esta Política descreve como a RODE IA pode tratar dados pessoais
          relacionados ao seu site institucional, contatos comerciais e serviços
          tecnológicos prestados aos seus clientes.
        </p>

        <h2>2. Site institucional</h2>
        <p>
          Na versão atual do site rodeia.com.br não existe formulário público
          ativo de cadastro, diagnóstico ou criação de conta.
        </p>
        <p>
          O site não utiliza, por iniciativa própria neste MVP, ferramentas de
          analytics, pixels publicitários ou gravação de sessão.
        </p>
        <p>
          O provedor de hospedagem e infraestrutura poderá processar dados
          técnicos necessários ao funcionamento e segurança do serviço, como
          endereço IP, data e hora da requisição, navegador e registros técnicos
          de acesso.
        </p>

        <h2>3. Contato</h2>
        <p>
          Quando uma pessoa entra voluntariamente em contato com a RODE IA por
          e-mail, podemos tratar as informações fornecidas na comunicação, como
          nome, endereço de e-mail, empresa e conteúdo da solicitação, para
          responder ao contato e dar continuidade à relação solicitada.
        </p>

        <h2>4. Serviços e integrações</h2>
        <p>
          Quando um cliente contrata e habilita serviços da RODE IA, podemos
          processar dados necessários à execução das integrações e automações
          contratadas.
        </p>
        <p>
          Dependendo do serviço, isso poderá incluir identificadores, dados de
          contato, eventos de sistemas, metadados de mensagens e conteúdo
          necessário à execução do processo autorizado.
        </p>
        <p>
          Quando atuarmos no tratamento de dados em nome de um cliente, o
          tratamento será realizado de acordo com o serviço contratado, as
          instruções aplicáveis e os controles técnicos disponíveis.
        </p>

        <h2>5. Integrações Meta e WhatsApp</h2>
        <p>
          Quando uma integração com produtos da Meta ou WhatsApp estiver
          efetivamente habilitada, a RODE IA poderá processar apenas os dados
          necessários à funcionalidade autorizada, conforme permissões,
          configuração da integração e finalidade do serviço.
        </p>
        <p>
          A existência desta Política não significa que todas essas integrações
          estejam ativas para todos os usuários ou clientes.
        </p>

        <h2>6. Compartilhamento</h2>
        <p>A RODE IA não vende dados pessoais.</p>
        <p>
          Dados poderão ser tratados por fornecedores de infraestrutura e
          tecnologia quando isso for necessário para prestar, proteger ou operar
          o serviço correspondente.
        </p>

        <h2>7. Retenção</h2>
        <p>
          Os dados são mantidos apenas pelo período necessário às finalidades
          para as quais foram tratados, observadas obrigações legais,
          contratuais ou de segurança aplicáveis.
        </p>

        <h2>8. Direitos e solicitações</h2>
        <p>
          Solicitações relacionadas a acesso, correção, atualização ou exclusão
          de dados podem ser enviadas para:{" "}
          <a href="mailto:privacidade@rodeia.com.br">privacidade@rodeia.com.br</a>.
        </p>
        <p>
          Podemos solicitar informações adicionais estritamente necessárias para
          verificar a identidade do solicitante e localizar os dados relacionados
          ao pedido.
        </p>

        <h2>9. Exclusão de dados</h2>
        <p>
          As instruções específicas estão disponíveis em:{" "}
          <a href="/exclusao-de-dados">
            https://rodeia.com.br/exclusao-de-dados
          </a>
          .
        </p>

        <h2>10. Segurança</h2>
        <p>
          Adotamos medidas técnicas e organizacionais proporcionais aos serviços
          operados para reduzir riscos de acesso, uso, alteração ou divulgação
          não autorizados.
        </p>
        <p>
          Relatos relacionados à segurança podem ser enviados para:{" "}
          <a href="mailto:suporte@rodeia.com.br">suporte@rodeia.com.br</a>.
        </p>

        <h2>11. Atualizações</h2>
        <p>
          Esta Política poderá ser atualizada para refletir alterações nos
          serviços, integrações ou requisitos aplicáveis. A versão vigente
          permanecerá disponível nesta URL.
        </p>

        <h2>12. Contato</h2>
        <p>
          RODE IA LTDA
          <br />
          CNPJ 68.764.921/0001-64
          <br />
          Privacidade:{" "}
          <a href="mailto:privacidade@rodeia.com.br">privacidade@rodeia.com.br</a>
          <br />
          Contato:{" "}
          <a href="mailto:contato@rodeia.com.br">contato@rodeia.com.br</a>
        </p>

        <p className="pt-6 text-neutral-500 italic">
          Este documento descreve a operação atual e poderá ser submetido a
          revisão jurídica conforme a evolução dos serviços da RODE IA.
        </p>
      </LegalPage>
    </PageShell>
  );
};

export default Privacidade;
